import { func, array } from "prop-types";

const propTypes = {
  handleForLastInList: func,
  items: array,
};

const ListGroup = (props) => {
  const { items, handleForLastInList } = props;

  return (
    <ul className="gv__list-group">
      {items?.length &&
        items.map((item, i) => {
          return (
            <li key={i} className="gv__list-group-item">
              <a
                href={item.href}
                target={item.target}
                className="gv__list-group-link"
                onKeyDown={handleForLastInList}
              >
                {item.label}
              </a>
            </li>
          );
        })}
    </ul>
  );
};

ListGroup.propTypes = propTypes;
export default ListGroup;
